import { createSelector } from 'reselect';

const notFoundSelector = state => state.notFound;

export const isNotFoundMountedSelector = createSelector([notFoundSelector], notFound => notFound.mountCount > 0);
